import { ContentGridComponent2 } from '../charts/content-grid-component2'
import { mostTweetedDocuments } from "../commons/data-placeholder";

export class AFTwitterMostRetweeted extends ContentGridComponent2 {
    static config = {
        selector: 'afTwitterMostRetweeted',
        controller: AFTwitterMostRetweeted,
        bindings: ContentGridComponent2.config.bindings,
        template: ContentGridComponent2.config.template,
    }

    setProperties() {
        this.mediaType = 'twitter';

        this.displayMode = 'indy'; //'standard'

        this.displaySettings = {
            isDocumentClickable: false,
            isSelectable: false,
            isAvatarVisible: true,
            isAvatarPaddingOn: false,
            isTitleTextVisible: false,
            isFixedMediaAspectRatio: true,
            isBlurEnabled: true,
            isIngressVisible: true,
            isMatchSentenceVisible: true,
            isMediaVisible: true,
            isMediaPlaceholderVisible: false,
            isKeywordsVisible: false,
            isKeywordsClickable: false,
            isTagsVisible: false,
            isDuplicatesVisible: false,
            inlineSentiment: false,
            isReachVisible: true,
            isSentimentVisible: false,
            isSocialEchoVisible: false,
            isSocialEngagementVisible: true,
            isHosted: false,
            mediaEmphasis: 'low',
        }

        this.componentSettings = {
            showTitle: false,
            showCustomFooter: true
        }

        this.pagination.pageSize = 3;

        this.pagination.contentLength = this.vizData.data.all.length;

        window.addEventListener('resize', () => {

            let cotentDiv = document.getElementById("documentDiv")
            let contentRowCount = this.getNumPerRow("#documentDiv")

            let pageWidth = cotentDiv.offsetWidth;
            this.updatePageSize(pageWidth, contentRowCount);

        });
    }

    private getNumPerRow = (selector) => {
        const grid: any = Array.from(document.querySelector(selector).children);
        const baseOffset = grid[0].offsetTop;
        const breakIndex = grid.findIndex(item => item.offsetTop > baseOffset);
        return (breakIndex === -1 ? grid.length : breakIndex);
    }

    // work around for page size and screen re/size
    // page size does not grow when the page grows, however it shrinks when the page shrinks
    // so below should fix both scenario
    private updatePageSize(pageWidth, contentRowCount) {

        let pageSize;

        if ((pageWidth > 900 && pageWidth < 1080) && contentRowCount < 2) {
            pageSize = 2
        } else if ((pageWidth > 1080 && pageWidth < 1360) && contentRowCount < 3) {
            pageSize = 3
        } else if ((pageWidth > 1360) && contentRowCount < 4) {
            pageSize = 4
        } else {
            pageSize = contentRowCount
        }

        this.pagination = Object.assign(this.pagination, { pageSize: pageSize, currentPage: 0 })
        this.prepareVisualizations(this.vizData.data)
    }

}
